import DentistIntro from "../../assets/images/dentist-intro-right-BK9LcyBo.png";
const DentistEnrollmentIntro = ({ onStart, onBack }) => {
  return (
    <div
      className="container"
      style={{ maxWidth: "1100px", marginTop: "50px" }}
    >
      <div className="row align-items-center">
        <div className="col-lg-6 mb-5 mb-lg-0 pe-lg-5">
          <p>
            <strong>Every new patient is valuable.</strong> Join the Dentist
            Match network and be one of the practices we recommend when patients
            in your area are actively searching for care.{" "}
            <strong>It's completely free</strong>, and your profile is shown to
            motivated patients—often right after a Smart Scan, a virtual
            consultation, or a Dental.com search—so you're connecting with
            ready-to-book opportunities, not chasing cold leads. Claim your
            spot, tell us the types of patients and services you want, and start
            welcoming high-quality new patients at no cost.
          </p>

          <button
            onClick={onBack}
            className="btn btn-outline-secondary rounded-pill px-5 py-3 fw-bold shadow-sm mx-1"
            style={{ fontSize: "1.1rem" }}
          >
            Back to Find Dentist
          </button>
          <button
            onClick={onStart}
            className="btn pi-btn-gradient text-white rounded-pill px-5 py-3 fw-bold shadow-sm"
            style={{ fontSize: "1.1rem" }}
          >
            Get Started
          </button>
        </div>

        <div className="col-lg-6 position-relative text-center">
          <img
            src={DentistIntro}
            alt="Smiling Dentist"
            className="img-fluid position-relative"
            style={{
              borderRadius: "10px",
              maskImage:
                "linear-gradient(to left, black 80%, transparent 100%)",
              WebkitMaskImage:
                "linear-gradient(to left, black 80%, transparent 100%)"
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DentistEnrollmentIntro;
